import * as React from 'react';
import Utils from '../../../utils';
import { DownloadStatus } from './styles';

interface ListItemDownloadStatusProps {
	isUpToDate: boolean;
	isUpdatable: boolean;
	isRowView: boolean;
}

const ListItemDownloadStatus = ({ isUpToDate, isUpdatable, isRowView }: ListItemDownloadStatusProps) => {

	return (
		<DownloadStatus isRowView={isRowView}>
			{getStatusElement(isUpToDate, isUpdatable)}
		</DownloadStatus>
	);
};

const getStatusElement = (isUpToDate: boolean, isUpdatable: boolean) => {
	if (!isUpToDate && !isUpdatable) {
		return null;
	}

	return isUpToDate
		? Utils.getSvgIcon('iconset_check-circle')
		: Utils.getSvgIcon('iconset_refresh')
	;
};

export default ListItemDownloadStatus;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ListItem/DownloadStatus/index.tsx